import { Route, Routes } from 'react-router-dom';

import DashboardCollectionsOptions from '../../../../src/features/analyticsPage/analyticsOptions/DashboardCollectionsOptions';
import ComposableDashboardContextProvider from '../../../../src/features/analyticsPage/context/ComposableDashboardContext';
import ComposableDashboardsCollectionsContextProvider from '../../../../src/features/analyticsPage/context/ComposableDashboardsCollectionContext';
import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import NoDataFoundCard from '../../../components/noDataFoundCard';
import CustomAnalyticsOptions from '../../../features/analyticsPage/analyticsOptions/CustomAnalyticsOptions';
import AnalyticsDashboardViewer from '../../../features/analyticsPage/components/dashboard/AnalyticsDashboardViewer';
import DashboardCollectionViewer from '../../../features/analyticsPage/components/dashboardCollection/DashboardCollectionViewer';
import ComposableDashboardFiltersContextProvider from '../../../features/analyticsPage/context/ComposableDashboardFiltersContext';
import ComposableDynamicListingContextProvider from '../../../features/analyticsPage/context/ComposableDynamicListingContext';
import {
  BusinessUnitSettings,
  JobsAndSkillsMatrix,
  OrganizationalUnitSettings,
} from '../../../features/clientsSettings/components';
import ClientUnits from '../../../features/clientsSettings/components/ClientUnits';
import StageStatusContextProvider from '../../../features/submissions/context/StageStatusContext';
import SkillsMatrix from '../../clientsSettings/components/SkillsMatrix';
import { OrganizationalScopeType } from '../../clientsSettings/types';
import TeamsList from '../../teams/components/TeamListNew';
import AllUsersInTeams from '../components/AllUsersInTeamsNew';
import TeamsAndUsers from '../components/TeamsAndUsers';
import UsersPage from '../UsersPage';

export const UserRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="Users - Wisestep">
          <UsersPage />
        </RouteWithTitle>
      }
    />
  </Routes>
);

export const TeamsAndUsersChildRoutes = () => (
  <ComposableDynamicListingContextProvider>
    <Routes>
      <Route
        path="/"
        element={<TeamsList forAnalyticsAndTeamMembersView={true} readOnlyMode={true} />}
      />
      <Route
        path="/users-list"
        element={<AllUsersInTeams key="users" forAccountManagerListing={false} />}
      />
      <Route
        path="/bussiness-units"
        element={<BusinessUnitSettings title="Teams Business Units" loadCurrentUserData={true} />}
      />
      <Route
        path="/organizational-unit-recruitment"
        element={
          <OrganizationalUnitSettings
            key={'recruitment'}
            title="Delivery Units Recruitment"
            scopeType={OrganizationalScopeType.Teams}
            readonlyMode={true}
          />
        }
      />
      <Route
        path="/account-managers"
        element={<AllUsersInTeams key="account_managers" forAccountManagerListing={true} />}
      />
      <Route path="/workspace-dashboards" element={<NoDataFoundCard text="Coming Soon" />} />
      <Route
        path="/account-manager-units"
        element={
          <OrganizationalUnitSettings
            key={'accpunt_manager'}
            title="Account Manager Units"
            scopeType={OrganizationalScopeType.Account_Managers}
            readonlyMode={true}
          />
        }
      />
      <Route
        path="/client-units"
        element={<ClientUnits title="Client Units" scopeType="Clients" />}
      />
      <Route
        path="/client-contacts-units"
        element={<ClientUnits title=" Client Contacts Units" scopeType="Client Contacts" />}
      />
      <Route path="/jobs-skills-matrix" element={<JobsAndSkillsMatrix />} />
      <Route
        path="/jobs-skills-matrix/job-demand-matrix"
        element={
          <RouteWithTitle title="Job Demand Matrix">
            <SkillsMatrix />
          </RouteWithTitle>
        }
      />
      <Route
        path="/jobs-skills-matrix/talent-matrix"
        element={
          <RouteWithTitle title="Talent Matrix">
            <SkillsMatrix />
          </RouteWithTitle>
        }
      />
      <Route
        path="/your-dashboards"
        element={
          <RouteWithTitle title="Your Dashboards - Wisestep">
            {/* Not needed here but added to avoid a crash */}
            <ComposableDashboardContextProvider>
              <ComposableDashboardsCollectionsContextProvider>
                <CustomAnalyticsOptions />
              </ComposableDashboardsCollectionsContextProvider>
            </ComposableDashboardContextProvider>
          </RouteWithTitle>
        }
      />
      <Route
        path="/your-dashboards/view"
        element={
          <RouteWithTitle title="Composable Analytics">
            <ComposableDashboardContextProvider>
              <ComposableDashboardFiltersContextProvider>
                <StageStatusContextProvider>
                  <AnalyticsDashboardViewer />
                </StageStatusContextProvider>
              </ComposableDashboardFiltersContextProvider>
            </ComposableDashboardContextProvider>
          </RouteWithTitle>
        }
      />
      <Route
        path="/master-dashboards"
        element={
          <RouteWithTitle title="Master Dashboards - Wisestep">
            <ComposableDashboardContextProvider>
              <ComposableDashboardsCollectionsContextProvider>
                <DashboardCollectionsOptions />
              </ComposableDashboardsCollectionsContextProvider>
            </ComposableDashboardContextProvider>
          </RouteWithTitle>
        }
      />
      <Route
        path="/master-dashboards/view"
        element={
          <RouteWithTitle title="Analytics Collections">
            <ComposableDashboardContextProvider>
              <ComposableDashboardsCollectionsContextProvider>
                <ComposableDashboardFiltersContextProvider>
                  <StageStatusContextProvider>
                    <DashboardCollectionViewer />
                  </StageStatusContextProvider>
                </ComposableDashboardFiltersContextProvider>
              </ComposableDashboardsCollectionsContextProvider>
            </ComposableDashboardContextProvider>
          </RouteWithTitle>
        }
      />
    </Routes>
  </ComposableDynamicListingContextProvider>
);

export const TeamsAndUsersRoutes = () => (
  <Routes>
    <Route
      path="/*"
      element={
        <ComposableDynamicListingContextProvider>
          <ComposableDashboardContextProvider>
            <ComposableDashboardsCollectionsContextProvider>
              <ComposableDashboardFiltersContextProvider>
                <TeamsAndUsers />
              </ComposableDashboardFiltersContextProvider>
            </ComposableDashboardsCollectionsContextProvider>
          </ComposableDashboardContextProvider>
        </ComposableDynamicListingContextProvider>
      }
    />
  </Routes>
);
